import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { catalogGraphTranslationRef } from '@backstage/plugin-catalog-graph';

export const catalogGraphTranslations = createTranslationResource({
  ref: catalogGraphTranslationRef,
  translations: {
    'pt-BR': () => import('./pt-BR'),
  },
});
